import { Portal } from '@bringg-frontend/bringg-web-infra';

import TaskRejectReasonsConfig from './task-reject-reasons-config';

const TaskRejectReasonsConfigPortal = () => (
	<Portal element={<TaskRejectReasonsConfig />} nodeId={'task-reject-reason'} />
);

export { TaskRejectReasonsConfigPortal };
